import { connect } from "react-redux";
import { PageLogin } from "senac-components";
import { userSlice, commonSlice } from "../store/reducers";
import {
  PageLoginDispatchProps,
  PageLoginStateProps,
} from "senac-components/dist/pages/Mobile/PageLogin";
import { PageLoginWeb } from "senac-components/dist/pages/Web/PageLogin";
import { RootState, AppDispatch } from "../store";
import { MenuOptions } from "senac-components/dist/pages/Mobile/PageInterfaces";
// import { commonSlice } from "../store/reducers";

const mapState = (state: RootState) => {
  let result: PageLoginStateProps = {
    loading: state.userState.projectsLoading,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  //Ação inicial:
  // dispatch(userSlice.actions.changeState('initializing'));

  const result: PageLoginDispatchProps = {
    onClickNext: (login: string) => dispatch(userSlice.actions.checkAvailableProjects(login)),
    onClickCollection: () => dispatch(commonSlice.actions.goToPage(MenuOptions.Home)),
    onClickForgotMyPassword: () => dispatch(commonSlice.actions.recoverPassword()),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    onClickBack: () => dispatch(commonSlice.actions.backPage())
  };

  return result;
};

const WPageLogin = () => {
  const Mobile = connect(mapState, mapDispatch)(PageLogin);
  const Web = connect(mapState, mapDispatch)(PageLoginWeb);
  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPageLogin };
